var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dg-language"},_vm._l((_vm.supportedLocales),function(supportedLocale){return _c('span',{key:supportedLocale,class:[
      'dg-language__item',
      {
        active: supportedLocale !== _vm.locale,
      },
    ],attrs:{"data-testId":'lang-' + supportedLocale},domProps:{"innerHTML":_vm._s(_vm.localeFlags[supportedLocale])},on:{"click":function($event){return _vm.onChangeLocale($event, supportedLocale)}}})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }